import { AbacoWebModule, MenuItem, RouterReadyEvent, ApplicationReadyEvent } from "@abaco/web-common/src/app";
import globals from "./globals";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import ChartsModule from "@abaco/dashboard-module/src/modules/charts";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import SupplyChainViewAPI from "../supply-chain-view-module/api/SupplyChainViewAPI";
import GlobalStateModule from "@abaco/portal-global-state/src/modules/global-state/index";
import routes from "./routes";
import { createMenu } from "./menu";
import SupplyChainVuexModule from "./state";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";
import SsoVuexModule from "@abaco/sso-web-module/src/abaco-module/state";

export const MODULE_ID = "supply_chain_view_module";

const state = new SupplyChainVuexModule();

interface ConstructorOptions {
    environment?: string;
}
export default class SupplyChainViewModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    public readonly environment!: string;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly routes = routes;
    readonly vuexModule = state;

    menu: MenuItem[] = [];

    private scsApi!: SupplyChainViewAPI;
    private apiCreated!: boolean;

    private ssoStore!: SsoVuexModule;

    constructor(options?: ConstructorOptions) {
        this.environment = options?.environment || "portal";
    }

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [ChartsModule.MODULE_ID]: () => new ChartsModule(),
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
    };

    onRouterReady(evt: RouterReadyEvent) {
        this.menu = createMenu(evt.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find((m) => m.id === SSOModule.MODULE_ID);
        if (!ssoModule) {
            throw new Error("ssoModule not found");
        }
        this.ssoStore = ssoModule.vuexModule as SsoVuexModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const SupplyChainViewAPI = (await import("./api/SupplyChainViewAPI")).default;
        this.scsApi = new SupplyChainViewAPI(http);
    }

    public get getSupplyChainViewAPI() {
        return this.scsApi;
    }
}
